import script from "./BecomePartnerSection.vue?vue&type=script&setup=true&lang=ts"
export * from "./BecomePartnerSection.vue?vue&type=script&setup=true&lang=ts"

import "./BecomePartnerSection.vue?vue&type=style&index=0&id=7927855a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7927855a"]])

export default __exports__